import { Box, FormControl, MenuItem, Select as MuiSelect } from "@mui/material";
import { styled } from "@mui/material/styles";
import { IconChevronDown } from "@tabler/icons-react";
import Text from "../ui/Text";

const StyledFormControl = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    "& fieldset": {
      borderColor: "#D4D4D4",
    },
    "&:hover fieldset": {
      borderColor: "#40A9FF",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1890FF",
    },
  },
  "& .MuiSelect-select": {
    padding: "10px 12px",
  },
  "& .MuiOutlinedInput-input": {
    padding: "6px 10px !important",
  },
  "& .MuiSelect-icon": {
    top: "50%",
    transform: "translateY(-50%)",
  },
});

const Select = ({
  label,
  options = [],
  value,
  onChange,
  error,
  // helperText,
  placeholder = "Select an option",
  icon = IconChevronDown,
  ...props
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: "100%",
      }}
    >
      {label && <Text variant="paragraph3">{label}</Text>}
      <StyledFormControl fullWidth error={error}>
        <MuiSelect
          value={value}
          onChange={onChange}
          displayEmpty
          IconComponent={icon}
          {...props}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(24, 144, 255, 0.04)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(24, 144, 255, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(24, 144, 255, 0.12)",
                  },
                },
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </MuiSelect>
      </StyledFormControl>
    </Box>
  );
};

export default Select;
